<template>
  <form class="nx-form" :class="{ 'nx-active': active }" :data-vv-scope="scope">
    <slot name="default"></slot>
  </form>
</template>

<script>
import Form from '@/modules/form/Form';

export default {
  name: 'nx-form-scope',
  extends: Form,
  inject: ['$validator'],
  computed: {
    formFields() {
      if (this.scope) {
        return this.getScopeFields(this.scope);
      }
      return Object.keys(this.fields).reduce((result, field) => {
        if (field.startsWith('$')) {
          return {
            ...result,
            ...Object.keys(this.fields[field]).reduce((scopeFields, scopeField) => ({
              ...scopeFields,
              [`${field}/${scopeField}`]: this.fields[field][scopeField],
            }), {}),
          };
        }
        return {
          ...result,
          [field]: this.fields[field],
        };
      }, {});
    },
  },
};
</script>
